import { AuxiliumComponent } from "../auxilium-component";

export class CarouselSlide extends AuxiliumComponent {
	static observedAttributes = ["active"];

	constructor() {
		super();

		this.active = this.hasAttribute("active");
	}

	attributeChanged(name, _, newValue) {
		if (name === "active") {
			if (this.IsAttributeValueTrue(newValue)) {
				[...this.closest("chip-carousel")?.querySelectorAll(":scope > div > ul > li > chip-carouselslide") ?? []]
					.forEach(x => x.active = x === this);
			}

			this.closest("chip-carousel")?.querySelector(".carousel__slide-list")?.scrollTo({ left: this.parentElement.offsetLeft, behavior: "smooth" });
		}
	}
}